// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Multistep_wrapper__3KILJ","dot":"Multistep_dot__3ajMP","active":"Multistep_active__2TB7n"};